import './AppsManage.sass';

import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Header, List, ListItem, Placeholder, ScrollView } from '$uikit';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';
import { AppModel } from '$store/models';
import { Api } from '$api';
import { IcAddCircle28 } from '$assets';
import { showModal } from '$navigation/helper';
import { useRoute } from 'react-router5';

export const AppsManage: FC = () => {
  const t = useTranslator();
  const [apps, setApps] = useState<AppModel[]>([]);
  const [loadingStatus, setLoadingStatus] = useState('loading');
  const { route } = useRoute();

  const loadData = useCallback(() => {
    setLoadingStatus('loading');
    Api.get('/app/manage')
      .then((resp) => {
        const data: any = resp;
        setApps(data.apps);
        setLoadingStatus('');
      })
      .catch(() => {
        setLoadingStatus('failed');
      });
  }, []);

  useEffect(() => {
    loadData();
  }, [route.params?.w]);

  function renderContent() {
    if (loadingStatus === 'loading') {
      return <Loader isWrapped />;
    }

    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={loadData}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    return (
      <div className="AppsManage">
        <List>
          <ListItem icon={<IcAddCircle28 />} onClick={() => showModal('createApp')}>
            Add App
          </ListItem>
          {apps.map((app) => (
            <ListItem key={app.id} onClick={() => showModal(`editApp${app.id}`)} chevron>
              {app.name}
            </ListItem>
          ))}
        </List>
      </div>
    );
  }

  return (
    <>
      <Header showBackButton>Apps</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
